import { Injectable, Optional } from '@angular/core';
import { IWsMessage } from '@core/models/web-socket.model';
import { StorageService } from '@services/common/storage.service';
import { ToasterService } from '@ui-kit/app-toast/toaster.service';
import { Socket } from 'ngx-socket-io';
import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class WebSocketService {
  private wsMessages$: Subject<IWsMessage<any>> = new Subject<IWsMessage<any>>();
  isConnected: boolean = false;

  socketInitUser(): void {
    const subscription = this._storage.getItem('subscription');
    const token = this._storage.getItem('token');
    const user = this._storage.getItem('user');

    this._socket.emit('message', {
      event: 'init',
      user: {
        ...user,
        token: 'Bearer ' + token,
        // @ts-ignore
        account_id: subscription?.account_id
      }
    });
  }

  constructor(
    private _toastService: ToasterService,
    private _storage: StorageService,
    @Optional() private _socket: Socket
  ) {
    this._socket.on('connect', () => {
      console.log('WebSocket connected!');
      this.isConnected = true;
      this.socketInitUser();

      this._socket
        .fromEvent('notify')
        .pipe(
          map((res) => {
            if (res.hasOwnProperty('message') && res.hasOwnProperty('channel')) {
              // @ts-ignore
              const message = res.message;
              this.wsMessages$.next({ event: message.event, data: message.data });
            }
          })
        )
        .subscribe();
    });

    this._socket.on('disconnect', () => {
      console.log('WebSocket disconnect!');
      this.isConnected = false;
    });
  }

  public on<T>(event: string): Observable<T> {
    if (event) {
      return this.wsMessages$.pipe(
        filter((message: IWsMessage<T>) => message.event === event),
        map((message: IWsMessage<T>) => message.data)
      );
    }
  }

  public send(event: string, data: any = {}): void {
    if (event && this.isConnected) {
      this._socket.emit('message', { event, data });
    }
  }
}
